import ImageLayer from "../ImageLayer";
import { LayerCustomType } from "../../interfaces";
import { QRCodeLayerProps, QRCodeProps } from "./interfaces";

export default class QRCodeLayer extends ImageLayer {
  protected static customType: LayerCustomType = LayerCustomType.QRCode;
  protected static defaultTypeProps: Partial<QRCodeProps> = {
    data: "Example data",
    dataColor: "#000",
    backgroundColor: "#0000",
    margin: 0,
    effectRatio: 0.8,
  };

  name: string = "QR code layer";
  qrCodeProps: Partial<QRCodeProps>;

  constructor(options: Partial<QRCodeLayerProps> = {}) {
    const {
      transformSettings = {},
      typeSettings = {},
      ...layerProps
    } = options;
    super();

    this.qrCodeProps = { ...QRCodeLayer.defaultTypeProps, ...typeSettings };
    this.set(transformSettings);
    this.set(layerProps);
  }

  toObject() {
    const object = super.toObject();
    const qrCodeProps = this.getQRCodeProps();
    return { ...object, typeSettings: qrCodeProps };
  }

  setQRCodeProps(props: Partial<QRCodeProps>) {
    this.qrCodeProps = { ...this.qrCodeProps, ...props };
    this.rerender();
  }

  getQRCodeProps(key?: keyof QRCodeProps) {
    if (key) {
      return this.qrCodeProps?.[key];
    } else {
      return { ...this.qrCodeProps };
    }
  }
}

export * from "./interfaces";
